export default __webpack_public_path__ + "cb32e22e3c9f5b4fa5b9a8d1f73f21cb.png";